import { render, staticRenderFns } from "./downloadPreview.vue?vue&type=template&id=060d2d70"
import script from "./downloadPreview.vue?vue&type=script&lang=js"
export * from "./downloadPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports